import * as React from "react";

function SvgVolt(props: React.SVGProps<SVGSVGElement>, svgRef?: React.Ref<SVGSVGElement>) {
  return <svg viewBox="0 0 16 16" ref={svgRef} {...props}><path d="M0 0h16v16H0z" fill="none" /><path d="M6.154 0a.615.615 0 00-.606.508L3.714 8.451a.641.641 0 00-.023.163.616.616 0 00.616.616h3.385l-.911 6.031a.626.626 0 00-.012.123.615.615 0 001.159.287l4.26-7.924-.006-.011a.6.6 0 00.125-.352.616.616 0 00-.616-.616H8.308l2.1-5.9A.614.614 0 009.846 0z" fill="currentColor" /></svg>;
}

const ForwardRef = React.forwardRef(SvgVolt);
export default ForwardRef;